var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconCelebration48(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2275_8996)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.333 17.0813V12.47",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 17.0813V12.47",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.667 17.0813V12.47",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3344 8.78101C17.0678 9.58362 17.5016 10.1951 17.6356 10.6153C17.8367 11.2457 17.6599 11.7878 17.1386 12.1737C16.6173 12.5595 16.0766 12.5781 15.5301 12.1737C14.9837 11.7692 14.8358 11.234 15.0331 10.6153C15.1647 10.2028 15.5984 9.59138 16.3344 8.78101Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0014 8.78088C24.7348 9.5835 25.1686 10.1949 25.3026 10.6152C25.5037 11.2456 25.3269 11.7877 24.8056 12.1736C24.2843 12.5594 23.7436 12.578 23.1971 12.1736C22.6507 11.7691 22.5027 11.2339 22.7001 10.6152C22.8316 10.2027 23.2654 9.59126 24.0014 8.78088Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.6684 8.78101C32.4018 9.58362 32.8356 10.1951 32.9696 10.6153C33.1707 11.2457 32.9939 11.7878 32.4726 12.1737C31.9513 12.5595 31.4106 12.5781 30.8641 12.1737C30.3177 11.7692 30.1697 11.234 30.3671 10.6153C30.4986 10.2028 30.9324 9.59138 31.6684 8.78101Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.86017 16.6202H40.1397C41.1584 16.6202 41.9842 17.4461 41.9842 18.4648V38.7548C41.9842 39.7735 41.1584 40.5993 40.1397 40.5993H7.86017C6.84146 40.5993 6.01562 39.7735 6.01562 38.7548V18.4648C6.01562 17.4461 6.84146 16.6202 7.86017 16.6202Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.86017 16.6202H40.1397C41.1584 16.6202 41.9842 17.4461 41.9842 18.4648V24.9207H6.01562V18.4648C6.01562 17.4461 6.84146 16.6202 7.86017 16.6202Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2275_8996"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0 0.502686)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconCelebration48);
export default __webpack_public_path__ + "static/media/pictogramBeaconCelebration48.7610a106150d41d52746fde1e96f7cba.svg";
export { ForwardRef as ReactComponent };